"use client";

import { useEffect, useState, useSyncExternalStore } from "react";
import Link from "next/link";

import { BrandLogo } from "@/src/components/brand-logo";

const emptySubscribe = () => () => undefined;

function useIsClient() {
  return useSyncExternalStore(emptySubscribe, () => true, () => false);
}

const navItems = [
  { href: "#solucoes", label: "Soluções" },
  { href: "#como-funciona", label: "Como funciona" },
  { href: "#empresas", label: "Para empresas" },
  { href: "#parceiros", label: "Parceiros" },
  { href: "#sobre", label: "Sobre" },
] as const;

export function SiteHeader() {
  const isClient = useIsClient();
  if (!isClient) {
    return <header className="sticky top-0 z-40 min-h-20 bg-[#08253e]" suppressHydrationWarning />;
  }
  return <SiteHeaderBar />;
}

function SiteHeaderBar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const close = () => setOpen(false);
    media.addEventListener("change", close);
    return () => media.removeEventListener("change", close);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <header className="sticky top-0 z-40 bg-[#08253e] text-white">
      <div className="mx-auto flex min-h-20 max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-4 sm:px-6 lg:px-10">
        <Link href="/" className="inline-flex items-center" aria-label="OBANKER início">
          <BrandLogo inverted priority className="h-8 w-40 max-w-[176px] sm:w-44" />
        </Link>
        <button
          type="button"
          aria-expanded={open}
          aria-controls="navigation"
          onClick={() => setOpen((value) => !value)}
          className="rounded-lg border border-white/50 px-4 py-2 text-sm lg:hidden"
        >
          {open ? "Fechar" : "Menu"}
        </button>
        <nav
          id="navigation"
          aria-label="Principal"
          className={`${open ? "flex" : "hidden"} w-full flex-col gap-1 text-sm lg:flex lg:w-auto lg:flex-row lg:items-center lg:gap-7`}
        >
          {navItems.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-3 text-white/90 transition-colors hover:bg-white/8 hover:text-white lg:px-0 lg:py-0"
            >
              {item.label}
            </Link>
          ))}
          <Link
            href="/login"
            onClick={() => setOpen(false)}
            className="rounded-lg border border-white/40 px-5 py-2.5 text-center text-white transition-colors hover:bg-white/10"
          >
            Entrar
          </Link>
        </nav>
      </div>
    </header>
  );
}
